import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import Home from "@/pages/Home";
import ContentPage from "@/pages/ContentPage";
import Gallery from "@/pages/Gallery";
import Donation from "@/pages/Donation";
import ContactPage from "@/pages/ContactPage";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    if (pathname === "/") document.title = "Wings of Fire Foundation | Ignite Awareness, Inspire Change";
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <div className="App bg-[#FAF7F2] overflow-x-clip">
      <BrowserRouter>
        <ScrollTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/donation" element={<Donation />} />
            <Route path="/contact-and-connect" element={<ContactPage />} />
            <Route path="/:slug" element={<ContentPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
